angular.module('lf.common')

.directive('bvProductPodsRatings', function (bazaarvoiceService) {
  return function (scope, el, attrs) {
    if (!lf.data.xhr.bazaarvoice.enableProductPodInlineRatings) return;
    
    var client = lf.data.xhr.client;
    var isDesktop = client.isDesktop || client.isLFC;
    var isMobile = client.isMobile || client.mobileUI;
    var podsSelector;
    
    if (isDesktop) {
      podsSelector = 'div.catalog-product div[data-ga-prod-id]';
    } else if (isMobile) {
      podsSelector = 'div.product-pod[data-ga-prod-id]:not([free-app-pod])';
    }
    
    var $pods = $(podsSelector);
    var products = {};
    var ids = $pods.toArray().map(function (pod) {
      var id = $(pod).data().gaProdId;
      products[id] = {
        productId: id,
        averageOverallRating: 0,
        overallRatingRange: 5
      }
      return id;
    });
    
    ids = _.uniq(ids);
    
    if (ids.length) {
      bazaarvoiceService.getProductsRatings(ids)
        .then(function (data) {
          if (data.products.length) {
            data.products.forEach(function (product) {
              var id = product.productId;
              $.extend(products[id], product);
            });
          }
          
          $pods.each(function () {
            var $pod = $(this);
            var id = $pod.data().gaProdId;
            var product = products[id];
            var $container = $('<div class="product-pod__bv-rating-container"></div>');
            var src = '//leapfrog.ugc.bazaarvoice.com/bvstaging/8818mexp-en_us/' + product.averageOverallRating + '/' + product.overallRatingRange + '/rating.png';
            var $img = $('<img class="product-pod__bv-rating-image" />');
            $img.attr('src', src);

            if (isDesktop) {
              var $a = $('<a></a>');
              var pdpUrl = $pod.find('p.heading > a').attr('href');
              $a.attr('href', pdpUrl);
              $a.append($img);
              $container.append($a);
              $container.insertAfter($pod.find('div.product-thumb'));
            } else if (isMobile) {
              $container.append($img);
              $container.insertBefore($pod.find('div.caption'));
            }
            
          });
        });
    }
  }
});
